import Cookies from 'js-cookie';
import { FACETS_CONFIG } from '@yme/common/constants';
import { COOKIE_COOKIE_HYPERDRIVE_SELECTED_UNIT_EXPIRE, COOKIE_HYPERDRIVE_SELECTED_UNIT, } from '@yme/pdp-components/ProductCard/CardAccessories/constants';
export function isProductsGridEmpty(props) {
    return (!props?.hyperdriveEndpoints ||
        !props?.hyperdriveEndpoints?.categoryInfo ||
        !props?.hyperdriveEndpoints?.productsByQuery ||
        !props?.labels);
}
export const getFilterFacetsConfig = (facetId) => {
    const list = FACETS_CONFIG[facetId];
    return list.map((item) => item.id);
};
export const setSelectedModelCookieFromUrl = ({ compatibleProductKeyByParam, CompatibilityProductKeyByCookie, languageRootPath, }) => {
    if (compatibleProductKeyByParam &&
        CompatibilityProductKeyByCookie !== compatibleProductKeyByParam &&
        languageRootPath) {
        Cookies.set(COOKIE_HYPERDRIVE_SELECTED_UNIT, compatibleProductKeyByParam, {
            expires: COOKIE_COOKIE_HYPERDRIVE_SELECTED_UNIT_EXPIRE,
            path: `${languageRootPath}/`,
        });
    }
};
